function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6219 0.000640428C13.2737 0.0130113 12.9437 0.169746 12.7021 0.437507C10.1107 3.2065 7.74688 5.93024 5.24346 8.64848L2.1747 6.0363C2.03744 5.91922 1.8799 5.83213 1.71107 5.77996C1.54223 5.7278 1.36542 5.71161 1.19071 5.73231C1.01601 5.753 0.846842 5.81018 0.692866 5.90058C0.538889 5.99099 0.403121 6.11283 0.293313 6.25918C0.183506 6.40553 0.101809 6.5735 0.0528867 6.75351C0.00396453 6.93352 -0.0112246 7.12204 0.00818684 7.30831C0.04739 7.6845 0.225148 8.02867 0.502357 8.26512L4.51599 11.6886C4.77324 11.9074 5.0971 12.0175 5.42567 11.9977C5.75424 11.978 6.06446 11.8299 6.29703 11.5816C9.17868 8.5026 11.7652 5.47263 14.5919 2.45236C14.786 2.25231 14.9188 1.99432 14.9729 1.71229C15.027 1.43026 14.9997 1.13738 14.8948 0.872146C14.7899 0.606913 14.6121 0.381729 14.385 0.226187C14.1578 0.0706451 13.8918 -0.00798269 13.6219 0.000640428Z",
  fill: "black"
});

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.424ca4c3.svg";
export { ForwardRef as ReactComponent };